import NoResults from '@/components/table/noResults';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { dateFormatter } from '@/shared/utils/date';
import guid from '@/shared/utils/guid';
import { format } from 'date-fns';
import { docusignRoutingTableColumns } from '../../constants';
import { EnvelopeRecipientDto } from '../../types';

interface TableBodyProps {
  docusignRoutingTableData: EnvelopeRecipientDto[];
}

const TableBody = ({ docusignRoutingTableData }: TableBodyProps) => {
  if (!docusignRoutingTableData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {docusignRoutingTableData.map((row) => (
        <TableRowWrapper key={guid()}>
          <TableRowCell width={docusignRoutingTableColumns[0].width}>
            <TextCell>{row.routingOrder}</TextCell>
          </TableRowCell>
          <TableRowCell width={docusignRoutingTableColumns[1].width}>
            <TextCell>{row?.completedAt && dateFormatter(format(new Date(row.completedAt), 'yyyy-MM-dd'), 'yyyy-MM-dd')}</TextCell>
          </TableRowCell>
          <TableRowCell width={docusignRoutingTableColumns[2].width}>
            <TextCell>{row.role}</TextCell>
          </TableRowCell>
          <TableRowCell width={docusignRoutingTableColumns[3].width}>
            <TextCell>{row.name}</TextCell>
          </TableRowCell>
          <TableRowCell width={docusignRoutingTableColumns[4].width}>
            <TextCell>{row.email}</TextCell>
          </TableRowCell>
        </TableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;
